module.exports = __webpack_public_path__ + "img/card.e27a9142.svg";